// Loader.js
import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="modern-spinner"></div>
      <p className="loader-text">Hold on, polishing the details ✨</p>
    </div>
  );
};

export default Loader;
